import { render, staticRenderFns } from "./AlarmHistoriesList.vue?vue&type=template&id=0d13dc2c"
import script from "./AlarmHistoriesList.vue?vue&type=script&lang=js"
export * from "./AlarmHistoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports